var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"574281dfaeb1ed6bfac5fdd7ce33602b061f37f0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lobby3-web@quantfive"]={id:"574281dfaeb1ed6bfac5fdd7ce33602b061f37f0"};
      